import { Component, Input, OnInit } from '@angular/core'
import { BrandLogoWidget } from 'htv-lib'
import { DynamicImageComponent } from '../dynamic-image/dynamic-image.component'
import { MediaService } from '../../services/media.service'

@Component({
  selector: 'app-brand-logo',
  standalone: true,
  imports: [DynamicImageComponent],
  templateUrl: './brand-logo.component.html',
  styleUrls: [],
})
export class BrandLogoComponent implements OnInit {
  @Input() config!: BrandLogoWidget

  url = ''

  constructor(private mediaService: MediaService) {
    // do nothing
  }

  ngOnInit(): void {
    if (this.config.mediaId) {
      this.url = this.mediaService.getMediaUrl(this.config.mediaId) ?? ''
    }
  }
}
